// Salesforce opportunity stages, as Harmonia reports them in `sfStage`.
//
// Held statically rather than fetched: the browser has no Harmonia
// credential (the key lives only in backoffice-api), and these are
// Salesforce's own pipeline stages, which change about as often as the
// sales process itself. If a stage is renamed in Salesforce, update this
// list — a value that no longer matches simply selects no customers.
//
// Ordered by pipeline progression, not alphabetically, so the list reads
// the way the sales funnel does.
export const CUSTOMER_STAGES = [
  "Discovery",
  "Qualify",
  "Prove Value",
  "Proposal",
  "Negotiate",
  "Closed Won",
  "Closed Lost",
] as const;

export type CustomerStage = (typeof CUSTOMER_STAGES)[number];

// What an operator most often means by "our customers": everyone still
// in play. Only a starting selection — there is no implicit audience, so
// whatever is selected here is what the broadcast reaches.
export const DEFAULT_CUSTOMER_STAGES: CustomerStage[] = CUSTOMER_STAGES.filter(
  (stage) => stage !== "Closed Lost",
);

// Stage targeting is resolved from Salesforce, which backoffice-api has
// configured in production only — the tenant ids held on Salesforce
// accounts are production ids. Where this is off the composer offers
// named tenants alone, and the backend 503s a stage audience rather than
// guessing at one.
export const CUSTOMER_STAGE_FILTER_ENABLED =
  import.meta.env.VITE_FEATURE_BROADCAST_STAGES === "true";
